export default "__VITE_ASSET__D4U3T1Ba__"